import { render, staticRenderFns } from "./ExamUpload.vue?vue&type=template&id=18bae356&scoped=true"
import script from "./ExamUpload.vue?vue&type=script&lang=js"
export * from "./ExamUpload.vue?vue&type=script&lang=js"
import style0 from "./ExamUpload.vue?vue&type=style&index=0&id=18bae356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bae356",
  null
  
)

export default component.exports